import React from 'react';
import { ThemeContext } from "../tokens/theme"
import styled from 'styled-components'

import useSound from 'use-sound';
import audio from "../static/filip-pizl.mp3"

//  const soundUrl = '/sounds/glug-a.mp3';

const $Button = styled.a`
    cursor: pointer;
    display: inline-block;
    
    & > svg{
        position: relative;
        top: 2px;
    }

    @media (min-width: 640px) {
        & > svg{
            top: -2px;
        }
    }
`

function Audio (props, children) {

    const [playbackRate, setPlaybackRate] = React.useState(1);

    const [play] = useSound(audio, {
        playbackRate,
        volume: 0.5,
    });

    const handleClick = () => {
        setPlaybackRate(playbackRate + 0.1);
        play();
    };
    
    return (
        <ThemeContext.Consumer>
        { context => (
            <$Button onClick={handleClick}>
                {props.children}
                <svg height="24" width="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM18.5 11.9961C18.5 13.7198 17.926 15.1411 17.3682 16.1172C17.0882 16.6073 16.8074 16.9939 16.5934 17.2614C16.4717 17.4134 16.3458 17.5639 16.2082 17.702C15.8229 18.0878 15.1791 18.0894 14.7929 17.7032C14.2055 17.1157 14.6283 16.5162 15.0316 16.012C15.1926 15.8107 15.4118 15.5098 15.6318 15.1249C16.074 14.351 16.5 13.2723 16.5 11.9961C16.5 10.7198 16.074 9.64112 15.6318 8.86719C15.4118 8.4823 15.1926 8.1814 15.0316 7.98012C14.6283 7.47595 14.2055 6.87637 14.7929 6.28895C15.1791 5.90271 15.8229 5.90428 16.2082 6.29007C16.3458 6.4282 16.4717 6.57869 16.5934 6.73073C16.8074 6.99821 17.0882 7.3848 17.3682 7.87491C17.926 8.85098 18.5 10.2723 18.5 11.9961ZM15 11.9961C15 12.9698 14.676 13.7661 14.3682 14.3047C14.2132 14.5761 14.0574 14.7908 13.9371 14.9411C13.5355 15.4431 12.8199 15.7302 12.2929 15.2032C11.9042 14.8145 11.9024 14.1855 12.2873 13.7946C12.2996 13.7816 12.4672 13.6004 12.6318 13.3124C12.824 12.976 13 12.5223 13 11.9961C13 11.4698 12.824 11.0161 12.6318 10.6797C12.4672 10.3917 12.2996 10.2105 12.2873 10.1975C11.9024 9.80656 11.9042 9.17759 12.2929 8.78895C12.8199 8.26191 13.5355 8.54899 13.9371 9.05105C14.0574 9.20133 14.2132 9.41605 14.3682 9.68741C14.676 10.226 15 11.0223 15 11.9961ZM7.27813 9.76822C7.09842 9.91798 6.87189 10 6.63795 10H4.875C4.56024 10 4.26952 10.1564 4.18128 10.4585C4.08965 10.7722 4 11.2666 4 12C4 12.7334 4.08965 13.2278 4.18128 13.5415C4.26952 13.8436 4.56024 14 4.875 14H6.63795C6.87189 14 7.09842 14.082 7.27813 14.2318L9.80851 16.3404C9.93574 16.4465 10.0748 16.5374 10.223 16.6115C10.58 16.79 11 16.5304 11 16.1312V7.86877C11 7.46962 10.58 7.21002 10.223 7.38852C10.0748 7.46259 9.93574 7.55355 9.80851 7.65958L7.27813 9.76822Z" fill={context.colorTheme.colorTextSecondary}/>
                </svg>
            </$Button>
        )}
    </ThemeContext.Consumer>
    );
};

export default Audio;